import type {
  ComponentRecordType,
  GenerateMenuAndRoutesOptions,
  RouteRecordStringComponent,
} from '@vben/types'

import { generateAccessible } from '@vben/access'
import { preferences } from '@vben/preferences'
import { mergeRoutes } from '@vben/utils'

import { message } from 'ant-design-vue'

import { menuApi } from '#/api'
import { BasicLayout, IFrameView } from '#/layouts'
import { $t } from '#/locales'
import { getMicroApp, getMicroAppName, isInMicroApp } from '#/micro-app'

const forbiddenComponent = () => import('#/views/_core/fallback/forbidden.vue')

async function generateAccess(options: GenerateMenuAndRoutesOptions) {
  const pageMap: ComponentRecordType = import.meta.glob('../views/**/*.vue')

  const layoutMap: ComponentRecordType = {
    BasicLayout,
    IFrameView,
  }
  const frontRoutes = options.routes

  return await generateAccessible(preferences.app.accessMode, {
    ...options,
    fetchMenuListAsync: async () => {
      let menus: RouteRecordStringComponent[] = []
      if (isInMicroApp()) {
        getMicroApp().setGlobalData({
          frontRouteMap: {
            ...(await getMicroApp().getGlobalData('frontRouteMap')),
            [getMicroAppName()!]: frontRoutes,
          },
        })
        menus = await getMicroApp().getData(getMicroAppName(), 'menus')
      } else {
        message.loading({
          content: `${$t('common.loadingMenu')}...`,
        })
        menus = await menuApi.getMenus()
        message.destroy()
      }

      const mereged = mergeRoutes(
        menus as any[],
        frontRoutes as any[],
      ) as unknown as RouteRecordStringComponent[]

      return mereged
    },
    // 可以指定没有权限跳转403页面
    forbiddenComponent,
    // 如果 route.meta.menuVisibleWithForbidden = true
    layoutMap,
    pageMap,
  })
}

export { generateAccess }
